import React from 'react';
import { Grid, Link, Typography } from '@material-ui/core';
import { formatDateObj, formatToCurrency } from '../Formatter';
import { useTranslation } from 'react-i18next';
import { AdmName } from '../AdmName';
import ShopOffer, { ShopOfferPosition } from '../../store/models/ShopOffer';
import { parse } from 'date-fns';
import Label from '../Label';
import i18next from 'i18next';
import { makeStyles } from '@material-ui/core/styles';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const useStyles = makeStyles((theme) => {
    return ({
        offerPosition: {
            paddingTop: '10px',
            flex: "0 max-content 0",
        },
        qtyField: {
            textAlign: 'right',
            width: '60px'
        },
        productNameField: {
            paddingLeft: theme.spacing(0.7),
        },
        priceField: {
            textAlign: 'right',
        },
        linkIcon: {
            fontSize: '1rem',
        },
    });
});

export default function ContactHistoryShopOfferDisplay({ offer }: { offer: ShopOffer }) {
    const classes = useStyles();
    //should use local time zone, we don't get specified tz from the shop api yet (just this: 2025-10-27 07:28:03.378)
    const offerCreationDate = parse(offer.createdAt, 'yyyy-MM-dd HH:mm:ss.SSS', new Date());

    const { t } = useTranslation();
    return <Grid container spacing={3}>
        <Grid item container xs={12} spacing={3}>
            <Grid item container xs={8} md={10}>
                <Grid item container xs={12}>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1">
                            {t('contactDetailCommunicationTab.offerCreatedAt')}{formatDateObj(offerCreationDate)}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1">
                            {t('contactDetailCommunicationTab.offerIsOrdered')}
                            {offer.isOrdered ? <Label color="success">{i18next.t('common.yes')}</Label> :
                                <Label color="error">{i18next.t('common.no')}</Label>
                            }
                        </Typography>
                    </Grid>
                </Grid>

                <Typography
                    variant="subtitle2">
                    {offer.persId ?
                        <>{t('contactDetailCommunicationTab.offerCreatedBy')}<AdmName personalnummer={offer.persId}/></>
                        : null}
                </Typography>
            </Grid>
            <Grid item xs={2}>
                <Link target="_blank" href={`https://www.berendsohn.de/sales/offers/${offer.offerId}`}>
                    {t('contactDetailCommunicationTab.offerLink')}<OpenInNewIcon className={classes.linkIcon}/>
                </Link>
            </Grid>
        </Grid>

        <Grid item container xs={12}>
            {offer.positions.map((p, i) => (
                <OfferPosition key={`${offer.offerId}-${encodeURIComponent(p.productName)}-${p.quantity}-${p.priceTotal}`} position={p} i={i}/>
            ))}
        </Grid>
    </Grid>;
}


function OfferPosition({ position, i }: { position: ShopOfferPosition, i: number }) {
    const classes = useStyles();

    return <Grid item container xs={12}
                 className={classes.offerPosition}>
        <Grid className={classes.qtyField} item>
            <Typography>{position.quantity} x</Typography>
        </Grid>
        <Grid xs={6} md={5} className={classes.productNameField} item>
            <Typography variant="body1" noWrap={true}>
                {position.productName}
            </Typography>
        </Grid>
        <Grid xs={2} item className={classes.priceField}>
            <Typography>{formatToCurrency(position.priceTotal, 'EUR')}</Typography>
        </Grid>
    </Grid>;
}